var jcsfApp;
(function (jcsfApp) {
    var app;
    (function (app) {
        var common;
        (function (common) {
            var services;
            (function (services) {
                var ValuesService = (function () {
                    function ValuesService(dataService, constantService) {
                        this.dataService = dataService;
                        this.constantService = constantService;
                        this.stateList = JSON.parse(window.localStorage.getItem('stateList'));
                        this.roleList = JSON.parse(window.localStorage.getItem('roleList'));
                        this.forestList = JSON.parse(window.localStorage.getItem('forestList'));
                        this.centerList = JSON.parse(window.localStorage.getItem('centerList'));
                        if (!this.stateList || !this.stateList.length || !this.roleList || !this.roleList.length || !this.centerList || !this.centerList.length || !this.forestList || !this.forestList.length)
                            this.fillLists(''); 
                    }
                    ValuesService.prototype.init = function () {
                        if (!this.forestList || !this.forestList.length)
                        this.getForests(); };
                    ValuesService.prototype.getForests = function () {
                        if (JSON.parse(window.localStorage.getItem('forestList'))) {
                            return JSON.parse(window.localStorage.getItem('forestList'));
                        }
                        return this.fillLists('forestList');
                    };
                    ValuesService.prototype.init = function () { if (!this.stateList || !this.stateList.length)
                        this.getStates(); };
                    ValuesService.prototype.getStates = function () {
                        if (JSON.parse(window.localStorage.getItem('stateList'))) {
                            return JSON.parse(window.localStorage.getItem('stateList'));
                        }
                        return this.fillLists('stateList');
                    };
                    ValuesService.prototype.getRoles = function () {
                        if (JSON.parse(window.localStorage.getItem('roleList'))) {
                            return JSON.parse(window.localStorage.getItem('roleList'));
                        }
                        return this.fillLists('roleList');
                    };
                    ValuesService.prototype.getCenters = function () {
                        if (JSON.parse(window.localStorage.getItem('centerList'))) {
                            return JSON.parse(window.localStorage.getItem('centerList'));
                        }
                        return this.fillLists('centerList');
                    };
                    ValuesService.prototype.fillLists = function (listToReturn) {
                        var $this = this;
                        return this.dataService.get(this.constantService.apiValuesURI +'get').then(function (result) {
                            $this.stateList = result.States;
                            $this.roleList = result.Roles;
                            $this.centerList = result.Centers;
                            window.localStorage.setItem('stateList', JSON.stringify($this.stateList));
                            window.localStorage.setItem('forestList', JSON.stringify($this.forestList));
                            window.localStorage.setItem('roleList', JSON.stringify($this.roleList));
                            window.localStorage.setItem('centerList', JSON.stringify($this.centerList));
                            if (listToReturn === 'roleList')
                                return $this.roleList;
                            if (listToReturn === 'forestList')
                                return $this.forestList;
                            if (listToReturn === 'stateList')
                                return $this.stateList;
                            if (listToReturn === 'centerList')
                                return $this.centerList;
                            return [];
                        });
                    };
                    return ValuesService;
                })();

								ValuesService.$inject = [
									'dataService',
									'constantService',
								];
                services.ValuesService = ValuesService;
                angular.module("jcsfApp")
                    .service("valuesService", ValuesService);
            })(services = common.services || (common.services = {}));
        })(common = app.common || (app.common = {}));
    })(app = jcsfApp.app || (jcsfApp.app = {}));
})(jcsfApp || (jcsfApp = {}));
